import React, { useState} from 'react'
import { Button } from 'primereact/button'; 
import { changeMessageSubmissionStatus, getOneMessageSubmission } from '../../api/axiosMessageSubmissions';
import { changePortalSubmissionStatus, getOnePortalSubmission } from '../../api/axiosPortalSubmissions';
// import { getAllPosts } from "../../../api/fetchPosts";
import {useNavigate } from 'react-router-dom';
import DeleteDialog from '../dialogs/DeleteDialog';
import { useContext } from 'react';
import DataContext from './../../context/DataContext';
import { getNotifications } from '../../api/axiosNotifications';




const ProcessDiscard = (
    {
        pkid,
        rowData,
        setSubmissions,
        setFetcherror,
        handleAllToasts,
        submissionType,
        setEditDialogVisible,
        handleOnEditSelectMessage,
        handleOnEditSelectPortal
    }) => {
    
        const {
            notifications, setNotifications,
            isLoadingNotifications, setIsLoadingNotifications,
            fetcherrorNotifications, setFetcherrorNotifications,auntheticatedUser
        } = useContext(DataContext);
    
    const operatorinitiated =  (auntheticatedUser?.role === "Admin" || auntheticatedUser?.role === "Operator" || auntheticatedUser?.role === "LHRCstaff") ? true:false
    
    
    const [dilogvisible, setDilogvisibleVisible] = useState(false);
    const navigate = useNavigate();

    const deleteFuction = (pkid, isprocessed, isdiscarded, setSubmissions, setFetcherror, handleAllToasts) => {
      
        
        if (submissionType === "message") {
            return () => {
               
                changeMessageSubmissionStatus(
                    pkid,
                    isprocessed,
                    isdiscarded,
                    setSubmissions,
                    setFetcherror,
                    handleAllToasts,
                        (err, data)=> {
                        if (data) {
                            getNotifications(setNotifications, setIsLoadingNotifications, setFetcherrorNotifications, operatorinitiated ? undefined : auntheticatedUser.id);
                        }
    
                     }
                );
            };
        }

        if (submissionType === "portal") {
            return () => {
                changePortalSubmissionStatus(
                    pkid,
                    isprocessed,
                    isdiscarded,
                    setSubmissions,
                    setFetcherror,
                    handleAllToasts,
                    (err, data) => {
                        if (data) {
                            getNotifications(setNotifications, setIsLoadingNotifications, setFetcherrorNotifications, operatorinitiated? undefined: auntheticatedUser.id);
                        }
                    }
                );
            };
        }
    };
    
    const dialogHeader = "Confirm Discarding the Incident";
    const dialogContents = (
        <p>Do you really want to Discard this Incident?, Click "Yes" to Proceed or "No" to Cancel</p>
    );
    


    return (
      
        <div className='flex flex-column justify-content-between'>

            <Button
                    outlined
                    label="Process"
                    icon="pi pi-pencil"
                    className=" p-button-primary px-3 py-1 text-xs mb-2 font-light"
                    onClick={() => {
                        // getOneMessageSubmission(pkid,setSubmissions, setFetcherror,handleAllToasts );
                        setEditDialogVisible(true);
                        if (submissionType === "message") handleOnEditSelectMessage(rowData);
                        if (submissionType === "portal") handleOnEditSelectPortal(rowData);
                }}
            />
                        
            <Button
                outlined
                label="Discard"
                icon="pi pi-trash"
                className="p-button-danger px-3 py-1 text-xs  font-light"
                //   tooltip="Discard"
                //   tooltipOptions={{ position: 'top' }}
                        onClick={() => {
                            setDilogvisibleVisible(true);
                        }} />
                    
            {
                dilogvisible &&
                <DeleteDialog
                    dilogvisible={dilogvisible}
                    setDilogvisibleVisible={setDilogvisibleVisible}
                    deletefucton={deleteFuction(pkid,true,true,setSubmissions,setFetcherror,handleAllToasts)}
                    dialogHeader={dialogHeader}
                    dialogContents={ dialogContents}
                    
                />
            } 
       
       </div>
  )
}

export default ProcessDiscard